import event1 from '../assets/events/event1.jpg'
import event2 from '../assets/events/event2.png'
import event3 from '../assets/events/event3.jpg'
import event4 from '../assets/events/event4.png'
import event5 from '../assets/events/event5.jpg'
import event6 from '../assets/events/event6.jpg'
import event7 from '../assets/events/event7.jpg'
import event8 from '../assets/events/event8.jpeg'
import event9 from '../assets/events/event9.jpg'
import event10 from '../assets/events/event10.png'
import event11 from '../assets/events/event11.png'



const Events = [
    {
        image: event7,
        name: 'KATALYST 2025',
        description: 'We flew to North Carolina to attend the Katalyst conference where we learned so many useful insighs for our future careers!',
    },
    {
        image: event8,
        name: 'KSEA Banquet 2025',
        description: 'Had a fun night at the Banquet and met people from other California KSEA chapters!',
    },
    {
        image: event10,
        name: 'Ski Trip 2025',
        description: 'Big Bear Ski Trip!',
    },
    {
        image: event9,
        name: 'Fall Retreat 2024',
        description: 'Retreat at Garden Grove!',
    },
     {
        image: event11,
        name: 'KATALYST 2024',
        description: 'First KSEA Katalyst Conference at Atlanta, Georgia',
    },
    {
        image: event1,
        name: 'Spring 2022 Valentine\'s Day Fundraiser',
        description: 'A successful fundraiser selling candy gify bags and cute plushies!',
    },
    {
        image: event2,
        name: '꿀Tips for Novice Researchers (Healthcare edition) Graduate Panel',
        description: 'Panel event for undergraduates for advice in professional research',
    },
    {
        image: event3,
        name: '꿀Tips for Researchers (Healthcare  edition) Undergraduate Panel',
        description: 'Panel event for undergraduates looking to join a lab!',
    },
    {
        image: event4,
        name: 'Spring 2022 General Meeting',
        description: 'Our first general meeting of 2022!',
    },
    {
        image: event5,
        name: 'Spring 2022 Boba Social',
        description: 'Fun night at Pot of Cha to meet new members!',
    },
    {
        image: event6,
        name: 'Ygnite 2022',
        description: 'A two-day conference to meet industry professional and students at Atlanta!',
    },
]

export default Events;